import React from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import BaseReportRecipients from '../../AbstractObjects/GatewayPlan/InnerPages/BaseReportRecipients';

const pageSchema = GatewayGetSchema.pages.reportRecipients;
const pageId = pageSchema.pageId;

function PlanReportRecipients({
    planObject,
    setPlanData,
    isHasEditPermissionForReportsConfig
}) {
    let pageData = planObject[pageId];
    
    return (
        <BaseReportRecipients
            pageData={pageData}
            setObjectData={setPlanData}
            isHasEditPermissionForReportsConfig={isHasEditPermissionForReportsConfig}
        />
    );
}

export default PlanReportRecipients;